<div
  #handle
  class="phx-slider-handle"
  [ngClass]="{ 'phx-disabled': disabled }"
  [attr.tabindex]="disabled ? null : 0"
  phx-tooltip
  [ngStyle]="phxStyle"
  [phxTooltipSize]="phxTooltipSize"
  [phxContent]="phxTooltipContent || tooltipContent"
  [phxTooltipContext]="tooltipContextData"
  [phxTrigger]="!disabled ? phxTooltipVisible : null"
></div>